import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export default class BreadcrumbItem extends AuxiliumComponent {
  static observable = ["link", "target", "icon", "variation"];

  constructor() {
    super();

    if (Browser.ResolveRelativeURL(this.link) === location.toString()) { this.link = ""; }
  }

  parsedCallback() {
    this.appendChild(document.createElementWithContents("span", this.childNodes));

    if (this.link) {
      const anchor = document.createElementWithContents("a", this.childNodes, { href: Browser.ResolveRelativeURL(this.link) });

      if (this.target) { anchor.target = this.target; }
      if (this.target === "_blank") { anchor.appendChild(document.createElementWithContents("span", Localizer.LINK_NEW_WINDOW, { className: "visually-hidden" })) }

      this.appendChild(anchor);
    }

    if (this.icon) { (this.link ? this.querySelector("a") : this).prepend(document.createElementWithContents("chip-icon", null, { icon: this.icon })); }
  }
}
